/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ converted: NonNullable<unknown>, total: NonNullable<unknown> }} Read_Along_First_PagesInputs */

const en_read_along_first_pages = /** @type {(inputs: Read_Along_First_PagesInputs) => LocalizedString} */ (i) => {const convertedPlural = registry.plural("en", i?.converted, {});
	if (convertedPlural === "one") return /** @type {LocalizedString} */ (`First page of ${i?.total}.`);
	if (convertedPlural === "other") return /** @type {LocalizedString} */ (`First ${i?.converted} of ${i?.total} pages.`);
	return /** @type {LocalizedString} */ ("read_along_first_pages");
};

const es_read_along_first_pages = /** @type {(inputs: Read_Along_First_PagesInputs) => LocalizedString} */ (i) => {const convertedPlural = registry.plural("es", i?.converted, {});
	if (convertedPlural === "one") return /** @type {LocalizedString} */ (`Primera de ${i?.total} páginas.`);
	if (convertedPlural === "other") return /** @type {LocalizedString} */ (`Primeras ${i?.converted} de ${i?.total} páginas.`);
	return /** @type {LocalizedString} */ ("read_along_first_pages");
};

/**
* | convertedPlural | output |
* | --- | --- |
* | "one" | "First page of {total}." |
* | "other" | "First {converted} of {total} pages." |
*
* @param {Read_Along_First_PagesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_first_pages = /** @type {((inputs: Read_Along_First_PagesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_First_PagesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_first_pages(inputs)
	return en_read_along_first_pages(inputs)
});